import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Portfolio',
    component: () => import('../views/Portfolio.vue'),
    meta: {
      title: 'Portfolio',
      hideSearchAndFilters: false
    }
  },
  {
    path: '/bookmarks',
    name: 'Bookmarks',
    component: () => import('../views/Bookmarks.vue'),
    meta: {
      title: 'Bookmarks',
      hideSearchAndFilters: false
    }
  },
  {
    path: '/more',
    name: 'More',
    component: () => import('../views/More.vue'),
    meta: {
      title: 'More',
      showPageTitle: true,
      hideHeaderFunctions: true,
      hideSearchAndFilters: true
    }
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('../views/About.vue'),
    meta: {
      title: 'About',
      showPageTitle: true,
      hideHeaderFunctions: true,
      hideSearchAndFilters: true
    }
  },
  {
    path: '/legal-information',
    name: 'LegalInformation',
    component: () => import('../views/LegalInformation.vue'),
    meta: {
      title: 'Legal Information',
      showPageTitle: true,
      hideHeaderFunctions: true,
      hideSearchAndFilters: true
    }
  },
  {
    path: '/override-endpoints',
    name: 'OverrideEndpoints',
    component: () => import('../views/OverrideEndpoints.vue'),
    meta: {
      title: 'Override Endpoints',
      showPageTitle: true,
      hideHeaderFunctions: true,
      hideSearchAndFilters: true
    }
  },
  {
    path: '/document/:id',
    name: 'Document',
    props: true,
    component: () => import('../views/Document.vue'),
    meta: {
      title: 'Document',
      hideHeaderFunctions: true,
      hideSearchAndFilters: true,
      hideFooter: true
    }
  },
  {
    path: '*',
    name: 'NotFound',
    component: () => import('../views/NotFound.vue'),
    meta: {
      title: 'Page Not Found',
      showPageTitle: false,
      hideHeaderFunctions: true,
      hideSearchAndFilters: true
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.VUE_APP_BASE_URL,
  routes
})

export default router
